/**
 * Labstep
 *
 * @module screens/Experiment/Show
 * @desc Experiment show
 */

import { ExperimentIsReady } from 'labstep-web/components/Experiment/IsReady';
import { ProtocolAlertTimer } from 'labstep-web/components/Protocol/Alert/Timer';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { Flex } from 'labstep-web/core/Flex';
import { Redirect } from 'labstep-web/core/Redirect';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Experiment } from 'labstep-web/models/experiment.model';
import { ScreensExperimentShowCenter as Center } from 'labstep-web/screens/Experiment/Show/Center';
import { ExperimentRight as Right } from 'labstep-web/screens/Experiment/Show/Right';
import { ScreensExperimentShowTopBar as ExperimentTopBar } from 'labstep-web/screens/Experiment/Show/TopBar';
import MasterShow from 'labstep-web/screens/Master/Show';
import type React from 'react';
import type {
  IExperimentShowScreenContainerProps,
  IExperimentShowScreenProps,
  IExperimentShowTopBarProps,
} from './types';

export const ExperimentShowScreenTopBar: React.FC<
  IExperimentShowTopBarProps
> = ({ id }) => (
  <EntityReadEntityContainer
    entityName={Experiment.entityName}
    id={id}
  >
    {({ entity: experiment }): JSX.Element | null =>
      experiment ? <ExperimentTopBar experiment={experiment} /> : null
    }
  </EntityReadEntityContainer>
);

export const ExperimentShowScreen: React.FC<
  IExperimentShowScreenProps
> = ({ experiment }) => (
  <>
    <ProtocolAlertTimer protocol={experiment} />

    <MasterShow
      entity={experiment}
      center={<Center experiment={experiment} />}
      right={<Right experiment={experiment} />}
    />
  </>
);

export const ExperimentShowScreenContainer: React.FC<
  IExperimentShowScreenContainerProps
> = ({ match }) => (
  <Flex column style={{ height: '100vh' }}>
    <ExperimentShowScreenTopBar id={match.params.id} />
    <ReadOnMountHOC
      type="entity"
      id={match.params.id}
      entityName={Experiment.entityName}
      loading={{ loader: 'show' }}
      children={({
        entity: experiment,
      }: {
        entity: Experiment;
      }): React.ReactElement => {
        if (!experiment.is_ready) {
          return <ExperimentIsReady experiment={experiment} />;
        }
        if (experiment.is_root) {
          return (
            <Redirect
              to="experiment_workflow_show"
              params={{ id: experiment.experiment_workflow.id }}
              state={{ is_root: true }}
            />
          );
        }
        return <ExperimentShowScreen experiment={experiment} />;
      }}
    />
  </Flex>
);
